module.exports = __webpack_public_path__ + "532159859c46ad36de26d51c6ab74387.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/multirotorsuperstore.png
 ** module id = 197
 ** module chunks = 0
 **/